export type FlowStepperStep = {
  label: string
}

type FlowStepState = 'done' | 'current' | 'upcoming'

type FlowStepperProps = {
  steps: FlowStepperStep[]
  /** Langkah aktif, 1-based. Nilai > steps.length = semua selesai. */
  activeStep: number
}

function getStepState(stepNumber: number, activeStep: number, totalSteps: number): FlowStepState {
  if (activeStep > totalSteps) return 'done'
  if (stepNumber < activeStep) return 'done'
  if (stepNumber === activeStep) return 'current'
  return 'upcoming'
}

export function FlowStepper({ steps, activeStep }: FlowStepperProps) {
  return (
    <div className="flex items-center gap-1">
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const state = getStepState(stepNumber, activeStep, steps.length)

        return (
          <div key={`${step.label}-${index}`} className="flex flex-1 items-center gap-1 min-w-0">
            <div className="flex flex-col items-center gap-1 flex-1 min-w-0">
              <div
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-label-md font-bold ${
                  state === 'done'
                    ? 'bg-status-success text-white'
                    : state === 'current'
                      ? 'bg-primary text-on-primary'
                      : 'bg-surface-container text-on-surface-variant border border-outline-variant'
                }`}
              >
                {state === 'done' ? (
                  <span className="material-symbols-outlined text-base">check</span>
                ) : (
                  stepNumber
                )}
              </div>
              <span
                className={`text-caption font-semibold text-center leading-tight truncate w-full ${
                  state === 'current' ? 'text-primary' : 'text-on-surface-variant'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-0.5 flex-1 min-w-2 mb-4 ${
                  activeStep > index + 1 ? 'bg-status-success' : 'bg-outline-variant'
                }`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
